/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {OepvMode} from './OepvMode';

/**
 * The RoutingParams model module.
 * @module model/RoutingParams
 * @version 0.0.2
 */
export class RoutingParams {
  /**
   * Constructs a new <code>RoutingParams</code>.
   * @alias module:model/RoutingParams
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>RoutingParams</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RoutingParams} obj Optional instance to populate.
   * @return {module:model/RoutingParams} The populated <code>RoutingParams</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RoutingParams();
      if (data.hasOwnProperty('maxTrainChanges'))
        obj.maxTrainChanges = ApiClient.convertToType(data['maxTrainChanges'], 'Number');
      if (data.hasOwnProperty('trainChangeTimeMin'))
        obj.trainChangeTimeMin = ApiClient.convertToType(data['trainChangeTimeMin'], 'Number');
      if (data.hasOwnProperty('vehicleRoutingMode'))
        obj.vehicleRoutingMode = ApiClient.convertToType(data['vehicleRoutingMode'], 'String');
      if (data.hasOwnProperty('oepvModes'))
        obj.oepvModes = OepvMode.constructFromObject(data['oepvModes']);
      if (data.hasOwnProperty('oepvModesOrigin'))
        obj.oepvModesOrigin = OepvMode.constructFromObject(data['oepvModesOrigin']);
      if (data.hasOwnProperty('oepvModesDestination'))
        obj.oepvModesDestination = OepvMode.constructFromObject(data['oepvModesDestination']);
      if (data.hasOwnProperty('minDistanceKm'))
        obj.minDistanceKm = ApiClient.convertToType(data['minDistanceKm'], 'Number');
      if (data.hasOwnProperty('maxDistanceKm'))
        obj.maxDistanceKm = ApiClient.convertToType(data['maxDistanceKm'], 'Number');
    }
    return obj;
  }
}

/**
 * used only for public transport vehicles. Max number of changes of trains allowed
 * @member {Number} maxTrainChanges
 */
RoutingParams.prototype.maxTrainChanges = undefined;

/**
 * used only for public transport vehicles.
 * @member {Number} trainChangeTimeMin
 */
RoutingParams.prototype.trainChangeTimeMin = undefined;

/**
 * routing mode used for Routing Service for the vehicle like escooter, car, bike
 * @member {String} vehicleRoutingMode
 */
RoutingParams.prototype.vehicleRoutingMode = undefined;

/**
 * @member {module:model/OepvMode} oepvModes
 */
RoutingParams.prototype.oepvModes = undefined;

/**
 * @member {module:model/OepvMode} oepvModesOrigin
 */
RoutingParams.prototype.oepvModesOrigin = undefined;

/**
 * @member {module:model/OepvMode} oepvModesDestination
 */
RoutingParams.prototype.oepvModesDestination = undefined;

/**
 * used only for individual vehicles (no OEPV). min-distance in km the vehicle should be used, i.e. if the distance this vehicle would be used for is less, then the route is discarded
 * @member {Number} minDistanceKm
 */
RoutingParams.prototype.minDistanceKm = undefined;

/**
 * used only for individual vehicles (no OEPV). max-distance in km the vehicle should be used, i.e. if the distance this vehicle would be used for is more, then the route is discarded
 * @member {Number} maxDistanceKm
 */
RoutingParams.prototype.maxDistanceKm = undefined;

